import { jsx as _jsx } from "react/jsx-runtime";
// Da spostare su componente a parte
import React, { useState, useEffect, useMemo } from "react";
import { BREAKPOINTS_DETAILED } from "../constants/breakpoints";
export const setRealDeviceHeight = () => {
    const vh = window.innerHeight;
    document.documentElement.style.setProperty("--device-view-height", `${vh}px`);
};
export const Context = React.createContext({
    device: {},
    forceDevice: undefined,
});
export const DeviceContext = ({ children, forceDevice }) => {
    const [device, setDevice] = useState({ height: 0, width: 0 });
    const handleResize = () => {
        setDevice({
            height: window.innerHeight,
            width: window.innerWidth,
        });
        setRealDeviceHeight();
    };
    const providerProps = useMemo(() => ({ device, forceDevice }), [device]);
    useEffect(() => {
        if (!forceDevice) {
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }
        setDevice({
            width: forceDevice === "desktop"
                ? BREAKPOINTS_DETAILED.desktop_s
                : BREAKPOINTS_DETAILED[forceDevice],
        });
        return () => { };
    }, []);
    return _jsx(Context.Provider, { value: providerProps, children: children });
};
